import SecureLS from "secure-ls";
import createPersistedState from 'vuex-persistedstate';

let secret = '7H6F4K8F4S6H8K5FDE';

const ls =  new SecureLS({isCompression: false, encodingType: 'rabbit', encryptionSecret: secret});

export default createPersistedState({
    key: 'TDCToolkit1',
    paths: ['authenticated', 'rtl'],
    storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
    }
});